import React from "react";
import Banner from "../Banner/Banner";
import Categories from "../Categories/Categories";
import Feature from "../Feature/Feature";

const Home = () => {
  return (
    <div>
      <Banner></Banner>
      <Categories></Categories>
      <Feature></Feature>
    </div>
  );
};

export default Home;
